import { render } from "./TeacherCardAbout.vue?vue&type=template&id=6638179b&scoped=true"
import script from "./TeacherCardAbout.vue?vue&type=script&lang=js"
export * from "./TeacherCardAbout.vue?vue&type=script&lang=js"

import "./TeacherCardAbout.vue?vue&type=style&index=0&id=6638179b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6638179b"]])

export default __exports__